export const FETCH_CLIENTS_START = "FETCH_CLIENTS_START";
export const FETCH_CLIENTS_SUCCESS = "FETCH_CLIENTS_SUCCESS";
export const INITIATE_BACKUP = "INITIATE_BACKUP";
export const INITIATE_STOP_BACKUP = "INITIATE_STOP_BACKUP";
export const STOP_BACKUP = "STOP_BACKUP";
export const INITIATE_PAUSE_BACKUP = "INITIATE_PAUSE_BACKUP";
//TODO: remove if not needed
export const PAUSE_BACKUP = "PAUSE_BACKUP";
export const INITIATE_RESUME_BACKUP = "INITIATE_RESUME_BACKUP";
export const RESUME_BACKUP = "RESUME_BACKUP";
export const UPDATE_BACKUP_PROGRESS = "UPDATE_BACKUP_PROGRESS";
export const ENABLE_BACKUP_CLIENT_DUMMY = "ENABLE_BACKUP_CLIENT_DUMMY";
export const ENABLE_BACKUP_CLIENT = "ENABLE_BACKUP_CLIENT";
export const ADD_NEW_BACKUP_CLIENT = "ADD_NEW_BACKUP_CLIENT";
export const CONFIGURE_BACKUP_CLIENT = "CONFIGURE_BACKUP_CLIENT";
export const UPDATE_BACKUP_MACHINE_STATUS = "UPDATE_BACKUP_MACHINE_STATUS";
export const UPDATE_BACKUP_MACHINES_STATUS = "UPDATE_BACKUP_MACHINES_STATUS";
export const DOWNLOAD_CLIENT_SETUP_START = "DOWNLOAD_CLIENT_SETUP_START";
export const DOWNLOAD_CLIENT_SETUP_COMPLETE = "DOWNLOAD_CLIENT_SETUP_COMPLETE";
export const REMOVE_CLIENT_FROM_LIST = "REMOVE_CLIENT_FROM_LIST";
export const UPDATE_CLIENT_INFO = "UPDATE_CLIENT_INFO";
export const BACKUP_SET_COMPLETED = "BACKUP_SET_COMPLETED";
export const BACKUP_SET_FAILED = "BACKUP_SET_FAILED";
export const RESTORE_SET_COMPLETION = "RESTORE_SET_COMPLETION";
export const RESTORE_SET_FAILURE = "RESTORE_SET_FAILURE";
export const UPDATE_RESTORE_PROGRESS = "UPDATE_RESTORE_PROGRESS";
export const REMOVE_RESTORE_STATE = "REMOVE_RESTORE_STATE";
export const INITIATE_STOP_RESTORE = "INITIATE_STOP_RESTORE";
export const STOP_RESTORE = "STOP_RESTORE";
export const UPDATE_IMAGE_RESTORE_PROGRESS = "UPDATE_IMAGE_RESTORE_PROGRESS";
export const REMOVE_BACKUP_TEMP_STATUS = "REMOVE_BACKUP_TEMP_STATUS";
export const DASHBOARD_API_DOWN = "DASHBOARD_API_DOWN";
export const HIDE_DASHBOARD_NOTIFY = "HIDE_DASHBOARD_NOTIFY";
export const FETCH_CLIENT_STATUS_START = "FETCH_CLIENT_STATUS_START";
export const FETCH_CLIENT_STATUS_SUCCESS = "FETCH_CLIENT_STATUS_SUCCESS";
export const FETCH_CLIENT_VERSION_INFO_START =
  "FETCH_CLIENT_VERSION_INFO_START";
export const FETCH_CLIENT_VERSION_INFO_SUCCESS =
  "FETCH_CLIENT_VERSION_INFO_SUCCESS";
export const FETCH_CLIENT_VERSION_INFO_FAILURE =
  "FETCH_CLIENT_VERSION_INFO_FAILURE";
export const FETCH_DEPLOYMENT_TOKEN_START = "FETCH_DEPLOYMENT_TOKEN_START";
export const FETCH_DEPLOYMENT_TOKEN_SUCCESS = "FETCH_DEPLOYMENT_TOKEN_SUCCESS";
export const DOWNLOAD_CLIENT_MSI_START = "DOWNLOAD_CLIENT_MSI_START";
export const DOWNLOAD_CLIENT_MSI_COMPLETE = "DOWNLOAD_CLIENT_MSI_COMPLETE";
export const FETCH_GROUPS_START = "FETCH_GROUPS_START";
export const FETCH_GROUPS_SUCCESS = "FETCH_GROUPS_SUCCESS";
export const FETCH_GROUPS_FAILURE = "FETCH_GROUPS_FAILURE";
export const ADD_CLIENTS_TO_GROUP_START = "ADD_CLIENTS_TO_GROUP_START";
export const ADD_CLIENTS_TO_GROUP_SUCCESS = "ADD_CLIENTS_TO_GROUP_SUCCESS";
export const ADD_CLIENTS_TO_GROUP_FAILURE = "ADD_CLIENTS_TO_GROUP_FAILURE";
export const DELETE_DASHBOARD_GROUP_START = "DELETE_DASHBOARD_GROUP_START";
export const DELETE_DASHBOARD_GROUP_SUCCESS = "DELETE_DASHBOARD_GROUP_SUCCESS";
export const DELETE_DASHBOARD_GROUP_FAILURE = "DELETE_DASHBOARD_GROUP_FAILURE";
export const RENAME_DASHBOARD_GROUP_NAME_START =
  "RENAME_DASHBOARD_GROUP_NAME_START";
export const RENAME_DASHBOARD_GROUP_NAME_SUCCESS =
  "RENAME_DASHBOARD_GROUP_NAME_SUCCESS";
export const RENAME_DASHBOARD_GROUP_NAME_FAILURE =
  "RENAME_DASHBOARD_GROUP_NAME_FAILURE";
export const CREATE_NEW_GROUP_DASHBOARD_START =
  "CREATE_NEW_GROUP_DASHBOARD_START";
export const CREATE_NEW_GROUP_DASHBOARD_SUCCESS =
  "CREATE_NEW_GROUP_DASHBOARD_SUCCESS";
export const CREATE_NEW_GROUP_DASHBOARD_FAILURE =
  "CREATE_NEW_GROUP_DASHBOARD_FAILURE";
export const REMOVE_CLIENTS_FROM_GROUP_START =
  "REMOVE_CLIENTS_FROM_GROUP_START";
export const REMOVE_CLIENTS_FROM_GROUP_SUCCESS =
  "REMOVE_CLIENTS_FROM_GROUP_SUCCESS";
export const REMOVE_CLIENTS_FROM_GROUP_FAILURE =
  "REMOVE_CLIENTS_FROM_GROUP_FAILURE";
export const FETCH_CLIENT_SERVERIPADDRESS_START =
  "FETCH_CLIENT_SERVERIPADDRESS_START";
export const FETCH_CLIENT_SERVERIPADDRESS_RESPONSE =
  "FETCH_CLIENT_SERVERIPADDRESS_RESPONSE";
export const SET_REDIRECT_RESTORE_TO_DASHBOARD_LOADER =
  "SET_REDIRECT_RESTORE_TO_DASHBOARD_LOADER";
export const CREATE_VIRTUALIZATION_ACCOUNT_START =
  "CREATE_VIRTUALIZATION_ACCOUNT_START";
export const INITIATE_VIRTUALIZATION_START = "INITIATE_VIRTUALIZATION_START";
export const INITIATE_VIRTUALIZATION_SUCCESS =
  "INITIATE_VIRTUALIZATION_SUCCESS";
export const CONTROL_VM_FROM_DASHBOARD_START =
  "CONTROL_VM_FROM_DASHBOARD_START";
export const CONTROL_VM_FROM_DASHBOARD_SUCCESS =
  "CONTROL_VM_FROM_DASHBOARD_SUCCESS";
export const CONTROL_VM_FROM_DASHBOARD_FAILURE =
  "CONTROL_VM_FROM_DASHBOARD_FAILURE";
